/**
 * Workout title display helper — mirrors backend behavior.
 *
 * If the title already contains a stylized quip (em dash), pass through.
 * Otherwise return the title as-is. Creative quips are generated by the
 * backend (witty_quip_llm) when async path is used; no hardcoded voice here.
 */

/**
 * Pass through title; if already styled (contains —), keep it; else show plain title.
 *
 * @param title - Base or pre-styled title from backend
 * @param _seed  - Unused; kept for API compatibility
 * @returns Title to display
 */
export function stylizeWorkoutTitle(title: string, _seed = ''): string {
  const t = (title ?? '').trim();
  if (!t) return 'Mystery Session';
  return t;
}
